export default { sendFile };

const PUT_TIMEOUT = 2 * 60 * 1000;

export function sendFile(params: any, done: (err: any, body: string) => void) {
  const { request, file, progress } = params;
  delete request.headers.host;
  const opts = {
    method: request.method,
    url: request.url,
    headers: request.headers,
    body: file,
    timeout: PUT_TIMEOUT,
    progress,
  };
  _request(opts, done);
}
function _request(params: any, done: (err: any, body: string) => void) {
  function request_done(...args) {
    if (done) {
      done(...args);
      done = null;
    }
  }
  const { method, url, headers, body, timeout, progress } = params;
  const xhr = new XMLHttpRequest();
  if (timeout) {
    xhr.timeout = timeout;
  }
  xhr.onload = () => {
    let status = xhr.status === 1223 ? 204 : xhr.status;
    let ret_body = false;
    let err = null;

    ret_body = xhr.response || xhr.responseText;
    if (status < 100 || status > 599) {
      err = 'bad_status';
    } else if (status > 399) {
      err = status;
    }
    request_done(err, ret_body);
  };
  xhr.onerror = () => {
    request_done('xhr_error');
  };
  xhr.ontimeout = () => {
    request_done('timeout');
  };
  xhr.open(method, url, true);
  for (let name in headers) {
    xhr.setRequestHeader(name, headers[name]);
  }
  let last_loaded = 0;
  if (progress) {
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const delta = e.loaded - last_loaded;
        const fraction = e.loaded / e.total;
        last_loaded = e.loaded;
        progress(fraction, delta, e.loaded);
      }
    };
  }
  xhr.send(body);
}
